<template>
  <ComplianceDataFieldRow :label="data.label" :value="reviewStatusText(status)" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { reviewStatusText } from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

const ComplianceDataStatusFragment = graphql(`
  fragment ComplianceDataStatus on ComplianceDataStatus {
    label
    statusValue {
      ... on VerifiedWorkerStatusValue {
        workerStatus: status
      }
      ... on RecruiterStatusValue {
        recruiterStatus: status
      }
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataStatusFragment> }>()
const data = computed(() => useFragment(ComplianceDataStatusFragment, props.entry))
const status = computed(() =>
  'workerStatus' in data.value.statusValue
    ? data.value.statusValue.workerStatus
    : data.value.statusValue.recruiterStatus,
)
</script>
